import React from 'react';
import Svg from '@styles/icons/svg';

import { scale } from '@components/frame';
import svgRegister from '@styles/icons/svg/svgRegister';
import { resolveLinkIcon, resolveLinkIconColor, LINK_STATUS_ICON, NC_FILE_STATUS } from './helpers/resolveLinkIcon';

interface LinkIconProps {
  linkStatus: keyof typeof LINK_STATUS_ICON;
  ncFileStatus: keyof typeof NC_FILE_STATUS;
  width?: number;
  height?: number;
  isWithERP: boolean;
  takeIntoAccountOnlyNcFileStatus?: boolean;
}

export default ({ linkStatus, ncFileStatus, isWithERP, width = scale(24), height = scale(24), takeIntoAccountOnlyNcFileStatus }: LinkIconProps) => {
  const icon = resolveLinkIcon({ linkStatus, ncFileStatus, isWithERP, takeIntoAccountOnlyNcFileStatus }) as keyof typeof svgRegister | null;
  const color = resolveLinkIconColor(ncFileStatus);

  if (!icon) return null;

  return <Svg icon={icon} width={width} height={height} color={color} />;
};
